import documentSvg from '../public/images/status/document.svg';
import foodSvg from '../public/images/status/food.svg';
import clothingSvg from '../public/images/status/clothing.svg';
import electronicsSvg from '../public/images/status/electronics.svg';
import fragileSvg from '../public/images/status/fragile.svg';
import medicalSvg from '../public/images/status/medical.svg';
import othersSvg from '../public/images/status/others.svg';
import trafficSvg from '../public/images/status/traffic.svg';

export const NEW = 'NEW';
export const SCHEDULING = 'SCHEDULING';

export const QUEUEING = 'QUEUEING';
export const PENDING_SCHEDULING = 'PENDING_SCHEDULING';

export const PENDING_PICKUP = 'PENDING_PICKUP';
export const PICKING_UP = 'PICKING_UP';

export const PENDING_DROP_OFF = 'PENDING_DROP_OFF';
export const DROPPING_OFF = 'DROPPING_OFF';

export const OPERATOR_CANCELLED = 'OPERATOR_CANCELLED';
export const SENDER_CANCELLED = 'SENDER_CANCELLED';
export const DRIVER_CANCELLED = 'DRIVER_CANCELLED';

export const COMPLETED = 'COMPLETED';
export const RETURNED = 'RETURNED';
export const FAILED_DELIVERY = 'FAILED_DELIVERY';

export const HIDE_ORDER_HOURS = 2;

export const STATUS_STAGE = {
  [NEW]: 1,
  [PENDING_PICKUP]: 1,
  [PICKING_UP]: 2,
  [PENDING_DROP_OFF]: 3,
  [DROPPING_OFF]: 4,
  [COMPLETED]: 5,
};

export const ITEM_TYPE_ICON = {
  '1': documentSvg,
  '2': foodSvg,
  '3': clothingSvg,
  '4': electronicsSvg,
  '5': fragileSvg,
  '6': medicalSvg,
  '7': othersSvg,
};

export const EXPECTATION_ICON = {
  '2': trafficSvg,
};

export const IN_TRANSIT_STATUS = [
  PENDING_PICKUP,
  PICKING_UP,
  PENDING_DROP_OFF,
  DROPPING_OFF,
  FAILED_DELIVERY,
];
